export default {
  //英文
  welcome: "Welcome to the NJU Mouse Phenotype Database",
  search: "Search",
  previousArticle: "Previous Article",
  nextArticle: "Next Article",
  home: "Home",
  phenotypeCompare: "Phenotype Comparison",
  compare: "Compare",
  total: "Selected",
  loginOrRegister: "Login/Register",
  personalInfo: "Personal Info",
  logout: "Logout",
  breedingType: 'Inventory Status',
  breedingTypes: 'Inventory Status',
  selectTwoPhenotype: "Please Select at Least 2 Strains for Comparison",
  maxCompare: "You Can Compare Up to 5 Strains at a Time",
  registerNJU: "Please Register the NJU Mouse Phenotype Database",
  registerName: "Please Enter Your Name, Length: 2-20 chars",
  registerPhone: "Please Enter Your Phone Number",
  registerGroup: "Please Enter the Name of Your Research Group",
  registerEmail: "Please Enter Your Email",
  registerCaptcha: "Please Enter the Verification Code",
  registerCaptchaCode: "Please Enter the Verification Code",
  sendEmail: "Send",
  password: "Password: 8-16 chars, uppercase and lowercase letters + numbers",
  password1: 'password',
  registerEmailCode: "Please Enter the Verification Code",
  rePassword: "Please Enter the Verification Code Again",
  registerBtn: "Register Now",
  loginTips: "Already Registered?",
  loginBtn: "Login",
  welcomeLogin: "Welcome Login",
  loginTips2: "Login to View Whole Phenotypic Data",
  loginSuccess: "Login Successful",
  findPassword: "Forget Password?",
  setPassword: "Please Input Your New Password",
  confirmPassword: "Please Confirm Your Password",
  confirmPasswordError: "Passwords Do Not Match",
  passwordError:
    "Password: 8-16 chars, uppercase and lowercase letters + numbers",
  emailError: "Invalid Email Format",
  forgetEmail: "Please Enter Your Email",
  forgetCaptcha: "Please Enter the Verification Code",
  sendSuccess: "Send Successful",
  resetSuccess: "Reset Successful",
  loginEmail: "Please Enter Your Email",
  loginPassword: "Please Enter Your Password",
  loginCaptcha: "Please Enter the Verification Code",
  noAccount: "No Account?",
  searchGene: "Please Input Gene Symbol or Gene NCBI ID",
  iconIntroduce: "Icon Instruction",
  embryoStemCell: "Embryo Cryopreservation",
  noEmbryoStemCell: "No Embryo",
  mouse: "Live Animal Archiving",
  noMouse: "No Live Animal Archiving",
  sperm: "Sperm Cryopreservation",
  noSperm: "No Sperm",
  compared: "Added",
  expand: "Expand",
  collapse: "Collapse",
  year: "year",
  month: "month",
  day: "day",
  pleaseEnterPasswordAgain: "Please Check Your Input",
  name: "Name",
  email: "Email",
  phone: "Phone Number",
  company: "Company",
  group: "Research Group",
  applicationResult: "Application Result",
  applicationTime: "Application Time",
  reset: "Reset",
  newApplication: "New Application",
  pleaseFillInTheFollowingInformation:
    "Please Fill in the Following Info to View Hidden Phenotypic Data",
  applicationInfo: "Application Info",
  pleaseEnterTheEmailAccount: "Please Enter the Email Account",
  pleaseEnterTheRemark: "Please Enter the Remark",
  emailAccount: "Email Account",
  remark: "Note",
  NJUMPDBNumber: "NJUMPDB_ID",
  addNJUMPDBNumber: "New NJUMPDB_ID",
  cancel: "Cancel",
  confirm: "Confirm",
  approved: "Approved",
  unapproved: "Unapproved",
  phenotypeNumberRepeat: "Strain ID Repeated",
  submitSuccess: "Submit Successful",
  atLeastOnePhenotypeNumber: "Please Select at Least 1 Strains",
  maxAddFivePhenotypeNumber: "You Can Add Up to 5 Strains",
  startTime: "Start Time",
  endTime: "End Time",
  youHaveAppliedTo: "You Have Applied to",
  owner: "Owner",
  applyToSeeTheFollowingPhenotypeNumberPermission:
    "Apply for the Permission about the Phenotypic Data of Following NJUMPD_ID Strains",
  agree: "Agree",
  disagree: "Disagree",
  productLineApplication: "Strain Application",
  passwordConfig: "Password Setup",
  mail: "Inbox Message",
  addCompare: "Add for Phenotypic Comparison",
  alias: "Gene Alias",
  fullName: "Gene Full Name",
  level: "Microbiological Status",
  background: "Background Strain",
  coatColor: "Strain Color",
  source: "Source of the Strain",
  target: "Edited Gene",
  njumId: "NJUMPD_ID",
  impc: "IMPC",
  num: "Number",
  doc: "doc",
  publications: "Publications",
  keepStatus: "Strain Archival Status",
  editType: "Gene Editing Strategy",
  gene: "Gene",
  materials: "Genotyping Materials",
  mon: "Mon",
  tue: "Tue",
  wed: "Wed",
  thu: "Thu",
  fri: "Fri",
  sat: "Sat",
  sun: "Sun",
  applicationPerson: "Applicant's Full Name",
  applicationInfo: "Applicant's Information",
  applicationPersonInput: "Please Enter Applicant's Full Name",
  unit: 'Affiliation (Work/Study Institution)',
  unitInput: 'Please Enter Your Affiliation (Work/Study Institution)',
  captchaCode: 'captchaCode',
  VerificationCode: 'Verification Code',
  gender: 'gender',
  male: 'male',
  female: 'female',
  birth: 'Date of Birth',
  birthInput: 'Please Select Date of Birth',
  labName: 'Laboratory Name',
  labNameInput: 'Please Enter Laboratory Name',
  confirmPwd: "Please Confirm Your Password",
  phoneRegister: 'Sign Up with Mobile',
  emailRegister: 'Sign Up with Email',
  accountInfo: 'Account Information',
  PI: 'Principal Investigator (PI)',
  PIInput: 'Please Enter Principal Investigator (PI)',
  researchField: 'Research Field',
  researchFieldInput: 'Please Enter Research Field',
  unitInfo: 'Institution Information',
  unitName: 'Institution Name',
  unitInfoInput: 'Please Enter Institution Name',
  identification: 'Taxpayer Identification Number (TIN)',
  identificationInput: 'Please Enter Taxpayer Identification Number (TIN)',
  unitAdd: 'Institution Address',
  unitAddInput: 'Please Enter Institution Address',
  submit: 'submit',
  register: 'register',
  sendCode: 'Verification code sent. Please check your messages.',
  gotoLogin: 'Registration successful. Please log in.',
  login: 'login',
  userCenter: 'User Center',
  cart: 'Cart',
  donation: 'Strain Remittance',
  changePwd: 'Change Password',
  resourceHome: 'Resource Catalog',
  resourceSearch: 'Resource Retrieval',
  theme: 'Resources by Topic',
  news: 'News & Announcements',
  techService: 'Technical Services',
  standard: 'Standards & Specifications',
  dataRemit: 'Data Curation',
  help: 'User Help',
  about: 'About Us',
  title: 'Nationnal Resource Center for Mutant Mice',
  forgetPassword: "Forget the password?",
  tips: 'Please enter your mobile number or email',
  userNameRequire: 'Username is required.',
  passwordRequire: 'Password is required.',
  links: 'Quick Links',
  quickNav: 'Quick Navigation',
  copyright: 'Copyright',
  contactUs: 'Contact Us',
  Address: 'Address: ',
  Tel: 'Tel: ',
  Email: 'E-mail: ',
  PageViews: 'Page Views: ',
  codeRequire: 'Verification code is required.',
  MouseRetrieval: 'Mouse Strain Retrieval',
  ArticleRetrieval: 'Article Retrieval',
  Pinned: 'Pinned',
  techType: 'Modification Type',
  searchRes: 'Search Results',
  result: 'Results for',
  countRes: 'Total: {count} results.',
  InventoryStatus: 'Inventory Status',
  SalesStatus: 'Sales Status',
  StrainDescription: 'Strain Description',
  IP: 'IP (Independent Pre-sale)',
  IF: 'IF (Available for Distribution)',
  RD: 'RD (Under Development)',
  IS: 'IS (Independent Strain)',
  unknown: 'Unknown or Confidential',
  StrainNumber: 'Strain Number',
  laws: 'Laws & Regulations',
  quality: 'Quality Standards',
  data: 'Data',
  upload: 'Upload',
  Strains: 'Strains',
  Donate: 'Donate',
  SubmitData: 'Submit Data',
  DonateStrains: 'Donate Strains',
  yearRepo: 'Resource Center Annual Report',
  qualificationDisclosure: 'Related Qualifications',
  industryUpdates: 'Industry Updates',
  qualityInspection: 'Quality Testing',
  welcome2: 'Welcome',
  articleRes: 'Article Search Results',
  views: 'Views',
  articleDetail: 'Article Details',
  articleSource: 'Article Source',
  date: 'Date',
  orderDetail: 'Order Details',
  count: 'count',
  unit: 'Work Affiliation',
  person: 'Contact Person',
  Handle: 'Handle',
  Shortlist: 'My Shortlist ',
  PendingOrder: 'Pending Order',
  OrderPlaced: 'Order Placed',
  AddtoShortlist: 'Add to Shortlist',
  shortlistLoginRequired: 'Please log in first.',
  shortlistAddFailed: 'Could not add to shortlist. Please try again.',
  contactConsult: 'Contact for Inquiry',
  infoOnly: 'Info Only',
  infoOnlyDescription: 'This strain is shared as information only, and no physical entity is stored in this resource center.',
  phenotypeConfidentialTag: 'Phenotype Confidential',
  phenotypeConfidentialDescription: 'This strain has phenotype information, but it is currently under a confidentiality period and the detailed content is not available.',
  Any: 'Any',
  female1: 'female',
  male1: 'male',
  Pair: 'Pair (1 Female + 1 Male)',
  Sperm: 'Sperm',
  WeeksOld: 'Week(s) Old',
  AddtoCart: 'Add to Cart',
  AddtoCart2: 'Add to Cart',
  SuccessfullyAdded: 'Successfully Added',
  DonationInfo: 'Strain Donation Information',
  ApplicationType: 'Application Type',
  FilterStatus: 'Filter Status',
  AllStatuses: 'All Statuses',
  Draft: 'Draft',
  PendingReview: 'Pending Review',
  Pending: 'Pending',
  Rejected: 'Rejected',
  AllTypes: 'All Types',
  ApplicationDate: 'Application Date',
  CurrentStatus: 'Current Status',
  detail: 'detail',
  withdraw: 'Withdraw',
  comfirmWithdraw: 'This action will withdraw this data. Are you sure you want to continue?',
  Notification: 'Notification',
  SubmissionForm: 'Data Submission Form',
  donationForm: 'Strain Remittance Form',
  dataUpload: 'Data Upload',
  resourceSearch: 'Resource Search',
  clear: 'Clear',
  selected: 'Selected Filters',
  Phenotype: 'Phenotype',
  reviewRecord: 'You can view your submission history under "Personal Account - Strain Remittance".',
  back: 'Back',
  seeNow: 'View Now',
  empty: 'Empty',
  index: 'Index',
  edit: 'Edit',
  dataUpload: 'Data Upload',
  did: 'Processed',
  del: 'Delete',
  editShortList: 'Edit Shortlist Item',
  orderTime: 'Order Time',
  serviceCase: 'Case Studies',
  serviceCaseDetail: 'Service Case Details',
  mouseAssembly: 'Mouse Assembly',
  mouseAssemblyContent: 'Content for Mouse Assembly to be added...',
  resourceSearch: 'Resource Search',
  clear: 'Clear',
  selected: 'Selected Filters',
  Phenotype: 'Phenotype',
  onlyShowPhenotypeStrains: 'Only show strains with phenotype data',
  noPhenotypeResultTitle: 'No strains with phenotype data were found for the current filters.',
  noPhenotypeResultDesc: 'Try turning off this switch or adjusting the keywords and filters.',
  noSearchResultTitle: 'No data found for the current filters.',
  noSearchResultDesc: 'Try adjusting the keywords or filters and search again.',
  resourceSimpleInfo: 'Resource Center Introduction',
  newsDetail: 'News Details',
  fullName2: 'Official Gene Symbol',
  alias2: 'Alias',
  chromosomeNumber: 'Chromosome',
  SubmissionTitle: 'What is Data Submission?',
  RemitTitle: 'What is Strain Remittance?',
  Remit: 'Strain Remittance',
  StrainRemittance: 'Strain Remittance',
  gjclmc: 'Strategy File Name',
  gjcllj: 'Strategy File Link',
  jdzlmc: 'Genotyping Data File Name',
  jdzllj: 'Genotyping Data File Link',
  currentPwd: 'Current Password',
  newPwd: 'New Password',
  inputPwd: 'Please enter your current password.',
  setNewPwd: 'Please set a new password.',
  pwdLimit: 'Password must be at least 8 characters long.',
  enterFirst: 'Please enter a value to filter the data.',
  gotoLogin2: 'Password modification successful. Please log in',
  confirmNewPassword: "Please Confirm Your New Password",
  themeDetail: 'Resources Details',
  inputEmailOrPhone: "Please Enter Your Phone Number Or Email",
  account: 'Account',
  newsTitle: 'News',
  standardTitle: 'Standards',
  findPWD: 'Reset Password',
  inputKey: 'Enter strain, gene, title, or keywords...',
  detailAddress: '12 Xuefu Road, Jiangbei New District, Pukou District Nanjing, Jiangsu Province, China',
  detailCopyright: 'National Resource Center for Mutant Mice (NRCMM) Nanjing University © Nanjing University - National Resource Center for Mutant Mice (NRCMM) Su ICP No. 1008945-1 Nan Xin Bei No. 1173',
  JCYK: 'Co-constructed by GemPharmatech Co., Ltd.',
  download: 'Download',
  GeneName: 'Gene Name',
  strainSearch: 'Strain Number or Strain Name or Njunum',
  Expand: 'Expand',
  Collapse: 'Collapse',
  newsTitle: 'News',
  homeHero: {
    platform: 'National Science and Technology Resource Sharing Platform',
    integration: 'Integrate Resources',
    sharing: 'Open Sharing',
    innovation: 'Empower Innovation',
    description: 'Meeting national needs for biomedical innovation and development, we provide innovative model development, resource collection and preservation, resource exploration and application, open sharing and services, common technology development, and management of mouse resources generated by national science and technology programs, while promoting international exchange and collaboration.',
    proteinGenes: 'Protein-coding genes targeted in the mouse genome',
    editedStrains: 'Genetically engineered mouse strains',
    conditionalStrains: 'Conditional knockout mouse strains',
  },
  geneResearch: {
    strainDescription: 'Strain Description',
    basicTitle: 'Strain Basics',
    basicSubtitle: 'Genetic background and resource preservation',
    background: 'Genetic background',
    documents: 'Strain Documents',
    strategyDocument: 'Construction strategy',
    genotypingDocument: 'Genotyping materials',
    noDocuments: 'No public attachments are available.',
    noFileLink: 'No link available',
    consultStrain: 'Ask about this strain',
    viewDocuments: 'View strain documents',
    phenotypeOverview: 'Phenotype Overview',
    informationTab: 'Information',
    strategyTab: 'Strategy',
    phenotypeTab: 'Phenotype',
    geneCount: '{count} associated genes · shown separately',
    hintsSubtitle: 'Gene-level research references',
    geneTitle: 'Genes and Functions',
    mouseGene: 'Mouse gene',
    function: 'Gene function',
    functionOriginal: 'Function reference text',
    noGenes: 'No gene records are available for this strain.',
    noFunction: 'No function reference is available.',
    loading: 'Loading references...',
    loadFailed: 'References could not be loaded.',
    detailFailed: 'Strain details could not be loaded.',
    retry: 'Retry',
    retryFunctions: 'Reload function references',
    notice: 'These gene-level functions and research associations do not establish this strain’s phenotypes, uses or chemical responses. Human ortholog associations are not direct mouse evidence.',
    researchField: 'Research areas',
    researchDirection: 'Research direction',
    directions: 'Research directions inferred from gene functions',
    directionsNotice: 'Separate from the strain’s existing research areas; not validated uses.',
    hints: 'Research Associations',
    diseases: 'Disease associations',
    chemicals: 'Drug / chemical associations',
    direct: 'Direct mouse associations',
    human: 'Human ortholog associations',
    directScope: 'The current OT collection contains human target relationships, not direct mouse associations.',
    drugScope: 'OT drug-target relationships include family and complex mappings, not necessarily direct single-protein binding. They do not cover all chemicals or establish this strain’s drug responses.',
    search: 'Search names or identifiers',
    filterGene: 'Filter associated genes',
    allGenes: 'All genes',
    sort: 'Sort order',
    nameSort: 'Sort by name',
    scoreSort: 'Sort by human ortholog score',
    score: 'Association score',
    noScore: 'No score available',
    scoreNotice: 'Open Targets direct human gene–disease scores; the highest available score is used for multiple genes. Not a probability or strain-level validation.',
    loaded: '{count} items loaded',
    more: 'Load more',
    notPublished: 'Reference data have not been published.',
    unresolved: 'Gene identity is not verified; associations are not shown.',
    notRecorded: 'No associations are recorded in the current reference collection.',
    noSearchResults: 'No matching associations were found.',
    refine: 'The paging limit was reached. Narrow the name or gene filters.',
  },
};
